import type { NativePurchaseAppPayload } from './types'

// SDKs released before bundleId was added only shipped in this app (on both platforms).
const LEGACY_NATIVE_BUNDLE_ID = 'com.playgama.twa'

export function getNativePurchaseBundleId(payload: NativePurchaseAppPayload | undefined): string {
    return typeof payload?.bundleId === 'string' && payload.bundleId.trim()
        ? payload.bundleId.trim()
        : LEGACY_NATIVE_BUNDLE_ID
}
